import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row q-col-gutter-md" }
const _hoisted_2 = { class: "col-12 col-lg-8" }
const _hoisted_3 = { class: "row q-col-gutter-md" }
const _hoisted_4 = { class: "col-12 col-sm-6" }
const _hoisted_5 = { class: "col-12 col-sm-6" }
const _hoisted_6 = { class: "col-12 col-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_clients_added_card = _resolveComponent("clients-added-card")!
  const _component_law_firm_users_card = _resolveComponent("law-firm-users-card")!
  const _component_resources_card = _resolveComponent("resources-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_clients_added_card, { "account-id": _ctx.accountId }, null, 8, ["account-id"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_law_firm_users_card, { "account-id": _ctx.accountId }, null, 8, ["account-id"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_resources_card)
    ])
  ]))
}